module.exports = __webpack_public_path__ + "img/Picture7.c801ec70.jpg";